module.exports = __webpack_public_path__ + "img/Filter.0a98e59d.svg";